"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToString = transformDateToString;
const DayOfWeek_1 = require("../utils/DayOfWeek");
const transformDateToMonthNameString_1 = require("./transformDateToMonthNameString");
function transformDateToString(date, showDayOfWeek = false, shortenMonth = false) {
    const dateToString = new Date(date);
    const year = dateToString.getUTCFullYear().toString();
    const month = (0, transformDateToMonthNameString_1.transformDateToMonthNameString)(dateToString).slice(0, shortenMonth ? 3 : undefined);
    const day = dateToString.getUTCDate().toString();
    let dayOfWeek = "";
    if (showDayOfWeek) {
        dayOfWeek = `${DayOfWeek_1.DaysOfWeek[dateToString.getUTCDay()]}, `;
    }
    return `${dayOfWeek}${month} ${day}, ${year}`;
}
//# sourceMappingURL=transformDateToString.js.map